import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import ColumnDragAndDrop from '../editors/ColumnDragAndDrop';
import {StepTypeConfigUISchemaV2} from '../step-config-settings/StepConfigUISchemas';
import {CUSTOM_COMPONENT_KEY, FIELD_ORDER_UI_SCHEMA_KEY} from '../StepConfigEditorTypes';

export const REORDER_COLUMNS_V0_UI_SCHEMA: StepTypeConfigUISchemaV2<PipelineStepType.REORDER_COLUMNS, 0> = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['reorderColumns'],
  reorderColumns: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['reorderColumns'],
    reorderColumns: {
      displayName: 'Columns',
      [CUSTOM_COMPONENT_KEY]: ColumnDragAndDrop,
    },
  },
};
